/**
 * パンくず：SP で文字がはみ出る場合のみクラスを追加
 */
const SP_BREAKPOINT = 767;
const OVERFLOW_CLASS = 'is-overflow';

function isSp() {
	return window.matchMedia(`(max-width: ${SP_BREAKPOINT}px)`).matches;
}

function checkOverflow(navEl) {
	if (!navEl) return;
	const listEl = navEl.querySelector('.breadcrumbs__list');
	if (!listEl) return;

	if (!isSp()) {
		navEl.classList.remove(OVERFLOW_CLASS);
		return;
	}

	const children = listEl.children;
	let childrenWidth = 0;
	for (let i = 0; i < children.length; i++) {
		childrenWidth += children[i].offsetWidth;
	}
	const gap = parseFloat(getComputedStyle(listEl).columnGap) || 0;
	if (children.length > 1) {
		childrenWidth += gap * (children.length - 1);
	}

	const hasOverflow = childrenWidth > listEl.clientWidth;
	navEl.classList.toggle(OVERFLOW_CLASS, hasOverflow);
}

export function init() {
	const navs = document.querySelectorAll('.breadcrumbs');
	if (!navs.length) return;

	navs.forEach((nav) => checkOverflow(nav));

	const resizeObserver = new ResizeObserver(() => {
		navs.forEach((nav) => checkOverflow(nav));
	});

	navs.forEach((nav) => {
		const list = nav.querySelector('.breadcrumbs__list');
		if (list) resizeObserver.observe(list);
	});

	window.addEventListener('resize', () => {
		navs.forEach((nav) => checkOverflow(nav));
	});
}
